export default {
      id: "icon-arrow-usage",
      viewBox: "0 0 32 28",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-arrow",
      toString: function () {
        return this.url;
      }
    }